/* EDG Fi Martingale session bridge — carries guided dog/profile data into the builder. */
(function () {
  'use strict';

  function guided() {
    return new URLSearchParams(window.location.search || '').get('edg_guided') === '1';
  }

  function pretty(value) {
    return Number(Number(value).toFixed(3)).toString();
  }

  function savedFiKind(dog) {
    if (!dog || dog.fiStatus !== 'yes') return '';
    var value = String(dog.fiSeries || '').toLowerCase();
    if (value.indexOf('mini') >= 0) return 'mini';
    if (value.indexOf('ultra') >= 0) return 'ultra';
    if (value.indexOf('2') >= 0) return 'integrated';
    if (value.indexOf('3') >= 0) return 'integrated';
    return '';
  }

  function redirectIfIncompatible(dog) {
    if (!guided() || !dog) return false;
    var kind = savedFiKind(dog);
    if (dog.fiStatus === 'no' || kind === 'mini' || kind === 'ultra') {
      window.location.replace('/products/martingale-collar?edg_guided=1');
      return true;
    }
    return false;
  }

  function save(root, session) {
    if (!root || !session) return;
    var neckField = root.querySelector('[data-neck]');
    var headField = root.querySelector('[data-head]');
    var neck = neckField ? Number(neckField.value) : 0;
    var head = headField ? Number(headField.value) : 0;

    if (session.saveMeasurement) {
      if (neck > 0) session.saveMeasurement('neck', pretty(neck));
      if (head > 0) session.saveMeasurement('head', pretty(head));
    }

    if (session.saveBuild) {
      session.saveBuild('martingale', {
        mode: 'fi',
        productHandle: root.dataset.productHandle || 'fi-martingale-collar',
        neck: neck > 0 ? pretty(neck) : '',
        head: head > 0 ? pretty(head) : '',
        closure: root.dataset.edgClosure || 'slip-over',
        sizingRule: root.dataset.edgSizingRule || '',
        size: root.dataset.sizeValue || '',
        fiIntent: root.dataset.fiIntent || '',
        fiSeries: root.dataset.fiSeries || '',
        fiGeneration: root.dataset.fiGeneration || '',
        webbingWidth: root.dataset.webbingWidth || '',
        color: root.dataset.colorValue || '',
        guided: guided()
      });
    }
  }

  function personalize(root, dog) {
    if (!dog) return;
    var heading = root.querySelector('.edg-guide__intro h2');
    if (heading && dog.name) heading.textContent = 'Build the right martingale for ' + dog.name + ', one decision at a time.';
    var referral = root.querySelector('[data-fi-referral]');
    if (referral && dog.fiStatus === 'yes' && dog.fiSeries) {
      referral.hidden = false;
      referral.innerHTML = '<strong>Saved Fi setup:</strong> ' + (dog.name ? dog.name + ' uses ' : 'You selected ') + dog.fiSeries + '. We’ll carry that forward and only ask for the choices this collar still needs.';
    }
  }

  function prefill(root, dog) {
    if (!guided() || !dog || !dog.measurements) return;
    var neck = Number(dog.measurements.neck);
    var head = Number(dog.measurements.head);
    var neckField = root.querySelector('[data-neck]');
    var headField = root.querySelector('[data-head]');
    if (neckField && neck > 0 && !Number(neckField.value)) neckField.value = pretty(neck);
    if (headField && head > 0 && !Number(headField.value)) headField.value = pretty(head);

    window.setTimeout(function () {
      if (neckField && Number(neckField.value) > 0) neckField.dispatchEvent(new Event('input', { bubbles: true }));
      if (headField && Number(headField.value) > 0) headField.dispatchEvent(new Event('input', { bubbles: true }));
    }, 180);
  }

  function normalizeOverlapRecommendation(root) {
    if (!root) return;
    var neckField = root.querySelector('[data-neck]');
    var headField = root.querySelector('[data-head]');
    var neck = neckField ? Number(neckField.value) : 0;
    var head = headField ? Number(headField.value) : 0;
    if (!(neck > 0 && head > 0)) return;

    var required = Math.max(neck, head);
    var buttons = Array.from(root.querySelectorAll('[data-size-choice]'));
    var custom = null;
    var matches = [];

    buttons.forEach(function (button) {
      var label = button.dataset.nativeValue || '';
      if (/custom/i.test(label)) { custom = button; return; }
      var match = label.match(/([0-9]+(?:\.[0-9]+)?)\s*[-–]\s*([0-9]+(?:\.[0-9]+)?)/);
      if (!match) return;
      var min = Number(match[1]);
      var max = Number(match[2]);
      if (required >= min && required <= max) matches.push({ button: button, min: min, max: max });
    });

    matches.sort(function (a, b) { return (b.min - a.min) || (b.max - a.max); });
    var recommended = matches.length ? matches[0].button : custom;
    buttons.forEach(function (button) {
      button.hidden = button !== recommended;
      if (button !== recommended) button.classList.remove('is-selected');
    });

    var question = root.querySelector('.edg-guide__size-results .edg-guide__question');
    if (question) question.textContent = 'EDG recommended size:';
    var note = root.querySelector('[data-size-note]');
    if (note) {
      if (!matches.length) note.textContent = 'The required opening falls outside the published standard ranges. Custom sizing is the correct next path.';
      else if (matches.length > 1) note.textContent = 'This measurement sits in an overlap. EDG recommends the larger matching published size.';
      else note.textContent = 'This is the published size range that contains the required opening.';
    }

    if (root.dataset.sizeValue && recommended && root.dataset.sizeValue !== recommended.dataset.nativeValue) {
      root.dataset.sizeValue = '';
    }
  }

  function preserveGuidedRoutes(root) {
    var standard = root.querySelector('[data-non-fi-route] .edg-guide__route-link');
    if (standard) standard.href = '/products/martingale-collar?edg_guided=1';
  }

  function init(marker, attempt) {
    if (!marker || marker.dataset.edgMartingaleSessionBridgeInitialized === 'true') return;
    var root = document.querySelector('[data-edg-guide]');
    var session = window.EDGBuildSession;
    if (!root || !session) {
      if ((attempt || 0) < 50) window.setTimeout(function () { init(marker, (attempt || 0) + 1); }, 60);
      return;
    }

    var dog = session.activeDog ? session.activeDog() : null;
    if (redirectIfIncompatible(dog)) return;

    marker.dataset.edgMartingaleSessionBridgeInitialized = 'true';
    root.dataset.edgSessionBridge = 'true';
    personalize(root, dog);
    preserveGuidedRoutes(root);
    prefill(root, dog);

    Array.from(root.querySelectorAll('[data-neck], [data-head]')).forEach(function (field) {
      field.addEventListener('input', function () {
        save(root, session);
        window.setTimeout(function () { normalizeOverlapRecommendation(root); }, 0);
      });
      field.addEventListener('change', function () {
        save(root, session);
        window.setTimeout(function () { normalizeOverlapRecommendation(root); }, 0);
      });
    });
    window.setTimeout(function () { normalizeOverlapRecommendation(root); }, 240);

    var observer = new MutationObserver(function () { save(root, session); });
    observer.observe(root, {
      attributes: true,
      attributeFilter: [
        'data-edg-closure', 'data-edg-sizing-rule', 'data-size-value', 'data-fi-intent',
        'data-fi-series', 'data-fi-generation', 'data-webbing-width', 'data-color-value'
      ]
    });

    root.addEventListener('edg:build:width', function () { save(root, session); });
    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-size-choice], [data-fi-intent-choice], [data-fi-series], [data-fi-new-series], [data-finish-review]')) {
        window.setTimeout(function () { save(root, session); }, 30);
      }
    });

    save(root, session);
  }

  function boot(scope) {
    var marker = (scope || document).querySelector('[data-edg-martingale-session-bridge]') || document.querySelector('[data-edg-martingale-session-bridge]');
    if (marker) init(marker, 0);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
